// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import './assets/sass/reset.css'
import './assets/sass/MaterialIcons.css'
import 'vue2-animate/dist/vue2-animate.min.css'
import store from './store'
import MuseUI from 'muse-ui'
import 'muse-ui/dist/muse-ui.css'
import Toast from 'muse-ui-toast'
import Message from 'muse-ui-message'
import VueTouch from 'vue-touch'
import 'muse-ui-loading/dist/muse-ui-loading.css'
import Loading from 'muse-ui-loading'

Vue.use(Loading)
Vue.use(Message)
Vue.use(Toast, {
  position: 'top'
})
Vue.use(VueTouch, { name: 'v-touch' })

Vue.use(MuseUI)
Vue.config.productionTip = false

Vue.directive('focus', {
  inserted: function(el) {
    el.focus()
  }
})

export default new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js